module.exports = __webpack_public_path__ + "static/media/NobleArtLogo.a027432c.svg";